module.exports = __webpack_public_path__ + "img/xinniangzaoxing.2f06d811.png";